/**
 * @file Defines constant for native routing of help files
 * @author Jordan Harrison <jordan.harrison@1x2network.com>
 * @version 1.0.32
 */

const queryString = window.location.search;
const urlParams = new URLSearchParams(queryString);
export const IS_NATIVE = urlParams.get("isNative") === "true" || false;
